module.exports = __webpack_public_path__ + "static/img/IMG_0418.39db699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0418.jpg
// module id = u0js
// module chunks = 12